import { createSelector } from "reselect";
import registrationTypes from "../utils/constants/user/registrationTypes";

const responsiblesSelector = (state: { responsibleState: { responsibles: any } }) =>
  state.responsibleState ? state.responsibleState.responsibles : [];

export const getResponsiblesState = createSelector([responsiblesSelector], (responsibles) =>
  responsibles.filter(({ status }: { status: string }) => status === registrationTypes.ACTIVE)
);

export const getAllResponsiblesState = createSelector(
  [responsiblesSelector],
  (responsibles) => responsibles
);

export const hasResponsiblesState = createSelector(
  [responsiblesSelector],
  (responsibles) => !!responsibles.length
);

export const getResponsibleName = createSelector(
  [responsiblesSelector],
  (responsibles) => (responsibleId: number) =>
    responsibleId
      ? (
          responsibles.find(
            ({ id, status }: { id: number; status: string }) =>
              id.toString() === responsibleId.toString() && status === registrationTypes.ACTIVE
          ) || {}
        ).name
      : ""
);

export const getAllResponsibleName = createSelector(
  [responsiblesSelector],
  (responsibles) => (responsibleId: number) =>
    responsibleId
      ? (
          responsibles.find(
            ({ id }: { id: string }) => id.toString() === responsibleId.toString()
          ) || {}
        ).name
      : ""
);

export const getAllResponsibleNames = createSelector(
  [responsiblesSelector],
  (responsibles) => (ids: number[]) =>
    ids
      ? (
          responsibles.filter(({ id }: { id: number }) =>
            ids.map((respId) => respId.toString()).includes(id.toString())
          ) || []
        ).map(({ name }: { name: string }) => name)
      : []
);

export const getResponsibleNames = createSelector(
  [responsiblesSelector],
  (responsibles) => (ids: number[]) =>
    ids
      ? (
          responsibles.filter(
            ({ id, status }: { id: number; status: string }) =>
              ids.map((respId) => respId.toString()).includes(id.toString()) &&
              status === registrationTypes.ACTIVE
          ) || []
        ).map(({ name }: { name: string }) => name)
      : []
);

export const getResponsibleIds = createSelector([responsiblesSelector], (responsibles) =>
  responsibles
    .filter(({ status }: { status: string }) => status === registrationTypes.ACTIVE)
    .map(({ id }: { id: number }) => id)
);

export const getResponsiblePhoto = createSelector(
  [responsiblesSelector],
  (responsibles) => (responsibleId: number) =>
    responsibleId
      ? (
          responsibles.find(
            ({ id }: { id: number }) => id.toString() === responsibleId.toString()
          ) || {}
        ).photo
      : ""
);
